/**
 * Classificação do fluxo de fechamento por forma de pagamento.
 * IDs espelham fpg_id do backend; flags na API podem substituir isso depois.
 */

export const PAYMENT_METHOD_SYS_PIX_ID = 5;

/** PIX manual (transferência para conta) — comprovante obrigatório. */
export const PAYMENT_METHOD_PIX_COMPROVANTE_ID = 13;

export type PaymentFlowKind =
	| "sys_pix_qr"
	| "pix_comprovante"
	| "caixa"
	| "unknown";

export function getPaymentFlowKind(
	paymentMethodId: number | null,
): PaymentFlowKind {
	if (paymentMethodId === null) return "unknown";
	if (paymentMethodId === PAYMENT_METHOD_SYS_PIX_ID) return "sys_pix_qr";
	if (paymentMethodId === PAYMENT_METHOD_PIX_COMPROVANTE_ID) {
		return "pix_comprovante";
	}
	return "caixa";
}

export function shouldShowComprovanteUpload(
	flowKind: PaymentFlowKind,
): boolean {
	return flowKind === "pix_comprovante" || flowKind === "caixa";
}

export function isComprovanteRequired(flowKind: PaymentFlowKind): boolean {
	return flowKind === "pix_comprovante";
}

/**
 * Agrupa a forma de pagamento selecionada para selecao de template de mensagem.
 * Usado pelo match.paymentFlow (pix / cartao / outros). Retorna null quando
 * nao ha metodo selecionado, para nao restringir a selecao do template.
 */
export function derivePaymentTemplateGroup(
	paymentMethod: {
		id: number | null;
		permiteParcelamento?: boolean;
	} | null,
): "pix" | "cartao" | "outros" | null {
	if (!paymentMethod || paymentMethod.id === null) return null;
	if (
		paymentMethod.id === PAYMENT_METHOD_SYS_PIX_ID ||
		paymentMethod.id === PAYMENT_METHOD_PIX_COMPROVANTE_ID
	) {
		return "pix";
	}
	if (paymentMethod.permiteParcelamento) return "cartao";
	return "outros";
}
